import type { HTMLAttributes } from "react";

import { DefinedDefaults, TWithDataComponent } from "@/ui/lib";
import { cn } from "@/ui/lib/utils";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const AVAILABLE_FLOATING_CONTAINER_TAGS = [ "div", "section", "article", "aside" ] as const;

export const FLOATING_CONTAINER_BASE_CLASS = cn(
  "flex flex-col gap-4",
  "rounded-sys-xs border border-solid border-strong",
  "bg-surface-default p-6",
  "shadow-neo-brutal",
);

/*-------------------------------------
|  Types
|-------------------------------------*/

type TFloatingContainerTag = typeof AVAILABLE_FLOATING_CONTAINER_TAGS[number];

export type TFloatingContainerProps = {
  tag?: TFloatingContainerTag;
} & TWithDataComponent & HTMLAttributes<HTMLElement>;

type TFloatingContainerDefaultProps = DefinedDefaults<
  TFloatingContainerProps,
  "tag" | "data-component"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const FLOATING_CONTAINER_DEFAULTS = {
  tag: "div",
  "data-component": "FloatingContainer",
} satisfies TFloatingContainerDefaultProps;
